// src/utils/constants.js

export const COMPANY_INFO = {
  name: 'NEVXOAULIO VENTURES',
  fullName: 'NEVXOAULIO VENTURES PRIVATE LIMITED',
  tagline: 'Making India Self-Reliant in Technology',
  whatsapp: '+919980031103',
  
  descriptions: [
    'Reversing brain drain by offering world-class salaries to Indian experts working abroad.',
    'Next-generation hybrid tech company specializing in software products, IT services, VLSI, cybersecurity, AI, and semiconductor fabrication.',
    'Building a hybrid tech empire that merges innovation, talent empowerment, and national self-reliance—establishing India as a global leader in software, AI, cybersecurity, VLSI, and semiconductor manufacturing.',
    'Eliminating dependency on foreign technology through in-house R&D across AI, blockchain, cybersecurity, and semiconductor fabrication.',
    'Allocating profits toward R&D, Government & Defence projects, and semiconductor manufacturing.',
    'Pioneering India\'s semiconductor revolution with indigenous fab and packaging technologies.',
    'Creating 5000+ high-tech jobs in India by 2030 through strategic investments.',
    'Partnering with IITs and NITs to build India\'s next-generation tech workforce.',
    'Developing sovereign AI models for strategic national applications.',
    'Building India\'s first end-to-end semiconductor ecosystem from design to manufacturing.'
  ],

  contact: {
    phone: '+91 94490 61503',
    email: 'info@nevxoaulio.com',
    address: 'Shylashree Nilaya, 2nd Floor, 2nd cross, Banashankari, Tumkur- 572102, India'
  },

  credentials: {
    cin: 'U62011KA2025OPC202304',
    msme: 'UDYAM-KR-25-0083581',
    startupIndia: 'DIPP209630',
    gstin: '29AAKCN4389A1Z7'
  },

  social: {
    linkedin: 'https://www.linkedin.com/in/nevxoaulio/',
    twitter: 'https://x.com/nevxoaulio/',
    facebook: 'https://facebook.com/nevxoaulio/',
    instagram: 'https://www.instagram.com/nevxoaulio/'
  }
};

export const SERVICES = [
  {
    id: 'software-development',
    name: 'Custom Software Development',
    icon: '💻',
    description: 'Tailored applications for startups, SMBs, and enterprises',
    features: ['Web, mobile, desktop solutions', 'ERP, CRM, eCommerce', 'API & cloud integration'],
    pricing: '$15,000 - $250,000+ per project',
    pricingModel: 'Fixed-price or Time & Materials'
  },
  {
    id: 'cyber-security',
    name: 'Cybersecurity & Ethical Hacking',
    icon: '🔒',
    description: 'Proactive defense and penetration testing',
    features: ['Network security', 'Vulnerability assessments', 'Incident response'],
    pricing: '$5,000 - $50,000 per assessment',
    pricingModel: 'Retainer or Project-based'
  },
  {
    id: 'cloud-computing',
    name: 'Cloud Solutions & DevOps',
    icon: '☁️',
    description: 'Run smarter, faster, and globally',
    features: ['AWS, Azure, GCP migration', 'CI/CD pipelines', 'Infrastructure automation'],
    pricing: '$3,000 - $25,000/month',
    pricingModel: 'Managed Services'
  },
  {
    id: 'blockchain',
    name: 'Blockchain & Web3',
    icon: '⛓️',
    description: 'Decentralized tech and smart contracts',
    features: ['Smart contracts', 'dApp development', 'NFT platforms'],
    pricing: '$25,000 - $500,000+ per project',
    pricingModel: 'Project-based'
  },
  {
    id: 'data-analytics',
    name: 'Data Science & Analytics',
    icon: '📊',
    description: 'Turn raw data into valuable insights',
    features: ['BI dashboards', 'Predictive analytics', 'ML model development'],
    pricing: '$10,000 - $150,000 per project',
    pricingModel: 'Project or Subscription'
  },
  {
    id: 'ai-automation',
    name: 'AI & Automation',
    icon: '🤖',
    description: 'Automate and optimize using AI',
    features: ['Chatbots & virtual assistants', 'RPA', 'AI integration'],
    pricing: '$20,000 - $300,000+ per implementation',
    pricingModel: 'Project-based'
  },
  {
    id: 'game-development',
    name: 'Game Development',
    icon: '🎮',
    description: 'Immersive games for mobile, PC, and web',
    features: ['Unity & Unreal Engine', 'Multiplayer integration', 'Live service support'],
    pricing: '$50,000 - $2,000,000+ per title',
    pricingModel: 'Milestone-based'
  },
  {
    id: 'vlsi',
    name: 'VLSI Software Services',
    icon: '🔌',
    description: 'Silicon to software innovation',
    features: ['RTL Design & Verification', 'ASIC & SoC Development', 'Physical Design'],
    pricing: '$100,000 - $1,000,000+ per engagement',
    pricingModel: 'Time & Materials or Project'
  },
  {
    id: 'startup-mvp',
    name: 'Startup & MVP Development',
    icon: '🚀',
    description: 'Bring ideas to market fast',
    features: ['MVP strategy & prototyping', 'Scalable architecture', 'Technical co-founder service'],
    pricing: '$25,000 - $150,000 for MVP',
    pricingModel: 'Equity + Cash or Fixed-price'
  }
];

export const PRODUCTS = [
  // Foundation Phase (Year 1-3)
  {
    name: 'SecureVault',
    category: 'Foundation',
    year: 2030,
    description: 'Military-grade encryption & decentralized vault for sensitive data and digital assets.',
    features: [
      'End-to-end encryption',
      'Multi-signature authentication',
      'Biometric security',
      'Disaster recovery',
      'Audit trails',
      'Compliance management'
    ],
    techStack: ['Node.js', 'PostgreSQL', 'Blockchain', 'Cryptography', 'AWS', 'Docker'],
    pricing: '$999 - $9,999/year'
  },
  {
    name: 'DataStream AI',
    category: 'Foundation',
    year: 2030,
    description: 'Real-time analytics platform for data-driven decision making and business intelligence.',
    features: [
      'Real-time data ingestion',
      'Advanced visualizations',
      'Predictive analytics',
      'Custom dashboards',
      'API integrations',
      'Auto-scaling infrastructure'
    ],
    techStack: ['React', 'Python', 'Apache Kafka', 'MongoDB', 'Redis', 'TensorFlow'],
    pricing: '$2,999 - $29,999/month'
  },
  {
    name: 'SmartSync',
    category: 'Foundation',
    year: 2030,
    description: 'IoT device management platform enabling seamless connectivity and control of smart devices.',
    features: [
      'Device onboarding',
      'Real-time monitoring',
      'Remote updates',
      'Anomaly detection',
      'Multi-protocol support',
      '99.99% uptime SLA'
    ],
    techStack: ['Node.js', 'MQTT', 'PostgreSQL', 'Redis', 'AWS IoT Core', 'Kubernetes'],
    pricing: '$1,999 - $19,999/month'
  },
  {
    name: 'CodeShield',
    category: 'Foundation',
    year: 2030,
    description: 'AI-powered code security scanner detecting vulnerabilities and enforcing best practices.',
    features: [
      'SAST & DAST scanning',
      'Vulnerability tracking',
      'Compliance automation',
      'CI/CD integration',
      'Threat remediation',
      'Security reporting'
    ],
    techStack: ['Python', 'Go', 'Machine Learning', 'LLVM', 'Git APIs', 'PostgreSQL'],
    pricing: '$999 - $9,999/month'
  },
  {
    name: 'MediAssist',
    category: 'Foundation',
    year: 2031,
    description: 'AI diagnostic assistant for healthcare professionals improving accuracy and efficiency.',
    features: [
      'Image analysis & diagnosis',
      'Patient record management',
      'Prescription automation',
      'Treatment recommendations',
      'Compliance with HIPAA',
      'Telemedicine integration'
    ],
    techStack: ['TensorFlow', 'Python', 'React', 'Node.js', 'PostgreSQL', 'AWS'],
    pricing: '$5,000 - $50,000/month'
  },
  {
    name: 'FinPulse',
    category: 'Foundation',
    year: 2031,
    description: 'Fintech platform providing real-time financial analytics and portfolio management.',
    features: [
      'Portfolio optimization',
      'Risk analysis',
      'Real-time market data',
      'Trading automation',
      'Regulatory compliance',
      'Multi-asset support'
    ],
    techStack: ['Node.js', 'React', 'Python', 'PostgreSQL', 'Redis', 'WebSocket'],
    pricing: '$10,000 - $100,000/month'
  },
  {
    name: 'EduVerse',
    category: 'Foundation',
    year: 2031,
    description: 'Personalized e-learning platform with AI tutoring and adaptive curriculum.',
    features: [
      'AI-powered tutoring',
      'Adaptive learning paths',
      'Student performance tracking',
      'Gamification elements',
      'Virtual classroom',
      'Progress analytics'
    ],
    techStack: ['React', 'Node.js', 'TensorFlow', 'PostgreSQL', 'WebRTC', 'AWS'],
    pricing: '$499 - $4,999/user/year'
  },

  // Expansion Phase (Year 4-5)
  {
    name: 'BlockChain Enterprise',
    category: 'Expansion',
    year: 2032,
    description: 'Enterprise blockchain infrastructure enabling secure, transparent transactions and smart contracts.',
    features: [
      'Hyperledger Fabric integration',
      'Smart contract development',
      'Multi-chain interoperability',
      'Consensus mechanisms',
      'Asset tokenization',
      'Enterprise scalability'
    ],
    techStack: ['Solidity', 'Hyperledger', 'Web3.js', 'Node.js', 'IPFS', 'PostgreSQL'],
    pricing: '$50,000 - $500,000/deployment'
  },
  {
    name: 'CloudBase',
    category: 'Expansion',
    year: 2032,
    description: 'Sovereign cloud infrastructure reducing India\'s dependency on foreign cloud providers.',
    features: [
      'Multi-region deployment',
      '99.999% uptime',
      'Compliance management',
      'Auto-scaling',
      'Disaster recovery',
      'Data sovereignty guarantee'
    ],
    techStack: ['Kubernetes', 'Docker', 'OpenStack', 'Linux', 'PostgreSQL', 'Custom hardware'],
    pricing: '$10,000 - $100,000/month'
  },
  {
    name: 'RoboControl',
    category: 'Expansion',
    year: 2032,
    description: 'Robotics command center for managing industrial robots and autonomous systems.',
    features: [
      'Real-time robot control',
      'Fleet management',
      'Autonomous navigation',
      'Computer vision integration',
      'Predictive maintenance',
      'Swarm coordination'
    ],
    techStack: ['ROS 2', 'Python', 'C++', 'OpenCV', 'MQTT', 'TensorFlow'],
    pricing: '$30,000 - $300,000/installation'
  },
  {
    name: 'BioMetric Guardian',
    category: 'Expansion',
    year: 2033,
    description: 'Advanced biometric authentication system with liveness detection and anti-spoofing.',
    features: [
      'Multi-modal biometrics',
      'Liveness detection',
      'Anti-spoofing AI',
      'Real-time identification',
      'Government compliance',
      '99.99% accuracy'
    ],
    techStack: ['TensorFlow', 'OpenCV', 'Python', 'Kubernetes', 'PostgreSQL', 'AWS'],
    pricing: '$100,000 - $1,000,000/deployment'
  },
  {
    name: 'VoiceCommand Pro',
    category: 'Expansion',
    year: 2033,
    description: 'Multilingual voice AI enabling voice-based interaction for Indian languages.',
    features: [
      'Indian language support',
      'Speech-to-text',
      'Text-to-speech',
      'Voice biometrics',
      'Accent adaptation',
      'Real-time processing'
    ],
    techStack: ['PyTorch', 'Wav2Vec', 'DeepSpeech', 'Python', 'Node.js', 'Kubernetes'],
    pricing: '$10,000 - $100,000/month'
  },

  // Advanced Phase (Year 6-8)
  {
    name: 'NeuroAPI',
    category: 'Advanced',
    year: 2034,
    description: 'Next-Gen Machine Learning APIs providing pre-trained models and custom model deployment for enterprises.',
    features: [
      'Pre-trained AI/ML models',
      'Custom model training',
      'Edge deployment capabilities',
      'Model versioning & rollback',
      'A/B testing framework',
      'Real-time inference'
    ],
    techStack: ['TensorFlow', 'PyTorch', 'FastAPI', 'Docker', 'Kubernetes', 'gRPC'],
    pricing: '$5,000 - $50,000/month'
  },
  {
    name: 'ImmersiVerse',
    category: 'Advanced',
    year: 2035,
    description: 'AR/VR Metaverse Platform enabling immersive experiences, virtual commerce, and collaborative spaces.',
    features: [
      'Avatar creation system',
      'Virtual commerce integration',
      'Real-time collaboration',
      'Cross-platform compatibility',
      'AI-powered NPCs',
      'Blockchain economy'
    ],
    techStack: ['Unity', 'Unreal Engine', 'WebXR', 'Node.js', 'PostgreSQL', 'Blockchain'],
    pricing: '$20,000 - $100,000/month'
  },
  {
    name: 'QuantaLab',
    category: 'Advanced',
    year: 2035,
    description: 'Quantum AI R&D Toolkit enabling quantum computing research and hybrid quantum-classical algorithms.',
    features: [
      'Quantum circuit builder',
      'Quantum simulator',
      'Hybrid algorithm framework',
      'Q-learning implementations',
      'Circuit optimization',
      'Device provider integration'
    ],
    techStack: ['Qiskit', 'Cirq', 'Python', 'Julia', 'AWS Braket', 'IBM Quantum'],
    pricing: '$10,000 - $100,000/year'
  },
  {
    name: 'PixelMind Engine',
    category: 'Advanced',
    year: 2036,
    description: 'AI-Based Game Dev Toolkit revolutionizing game development with procedural generation and intelligent NPCs.',
    features: [
      'Procedural world generation',
      'AI behavior trees',
      'Dynamic difficulty adjustment',
      'Procedural animation',
      'Real-time ray tracing',
      'Cross-platform deployment'
    ],
    techStack: ['Unreal Engine 5', 'Python', 'C++', 'NVIDIA DLSS', 'ray-tracing'],
    pricing: '$2,000 - $15,000/month'
  },
  {
    name: 'AutoMech',
    category: 'Advanced',
    year: 2036,
    description: 'Autonomous Robotics + IoT Framework enabling industrial automation and smart manufacturing solutions.',
    features: [
      'Autonomous control systems',
      'IoT sensor integration',
      'Real-time monitoring',
      'Predictive maintenance',
      'Swarm robotics coordination',
      'Machine vision integration'
    ],
    techStack: ['ROS 2', 'Python', 'C++', 'MQTT', 'TensorFlow', 'OpenCV'],
    pricing: '$50,000 - $500,000/deployment'
  },

  // Moonshot Phase (Year 9-15)
  {
    name: 'ShieldOne',
    category: 'Moonshot',
    year: 2037,
    description: 'Fully Automated AI Cybersecurity Grid providing nation-level threat protection and autonomous defense.',
    features: [
      'Autonomous threat response',
      'Zero-trust architecture',
      'AI-powered threat hunting',
      'Quantum-resistant encryption',
      'Global threat intelligence',
      'Self-healing networks'
    ],
    techStack: ['Python', 'C++', 'Quantum crypto', 'AI/ML', 'Blockchain', 'Government APIs'],
    pricing: '$100,000 - $1,000,000/year'
  },
  {
    name: 'CivicChain',
    category: 'Moonshot',
    year: 2038,
    description: 'Blockchain Government Infrastructure Suite transforming public services through decentralized governance.',
    features: [
      'E-governance platform',
      'Smart contract-based voting',
      'Transparent budget allocation',
      'Citizen identity verification',
      'Land record management',
      'Permit & license automation'
    ],
    techStack: ['Hyperledger Fabric', 'Solidity', 'Node.js', 'PostgreSQL', 'IPFS', 'Government protocols'],
    pricing: 'Government contracts - Custom'
  },
  {
    name: 'SmartCityOS',
    category: 'Moonshot',
    year: 2038,
    description: 'AI + Robotics Urban Management Suite enabling fully automated smart cities with real-time optimization.',
    features: [
      'Traffic management AI',
      'Energy grid optimization',
      'Waste management automation',
      'Environmental monitoring',
      'Autonomous transportation',
      'Emergency response coordination'
    ],
    techStack: ['Python', 'IoT', 'Robotics', 'AI/ML', '5G', 'Edge computing'],
    pricing: '$5,000,000 - $50,000,000/city'
  },
  {
    name: 'StellarAI',
    category: 'Moonshot',
    year: 2039,
    description: 'AI-Powered Aerospace Command Systems providing autonomous flight, satellite management, and space exploration.',
    features: [
      'Autonomous flight control',
      'Satellite orbit management',
      'Space debris tracking',
      'Quantum communications',
      'Mission planning AI',
      'Real-time telemetry'
    ],
    techStack: ['C++', 'Python', 'Real-time OS', 'Quantum comms', 'Aerospace APIs'],
    pricing: 'Government/ISRO contracts - Custom'
  },
  {
    name: 'QuantumSentience',
    category: 'Moonshot',
    year: 2040,
    description: 'Ultra-Secure Quantum Supercomputing AI combining quantum computing with advanced AI for breakthrough innovations.',
    features: [
      'Quantum-classical hybrid computing',
      'Post-quantum cryptography',
      'Exascale AI processing',
      'Universal problem solving',
      'Autonomous research',
      'Global security infrastructure'
    ],
    techStack: ['Quantum hardware', 'AI/ML', 'Post-quantum crypto', 'Advanced semiconductor tech'],
    pricing: '$1,000,000 - Custom enterprise'
  }
];